import ParticleField from "@/components/ParticleField";
import { Instagram, Facebook, ArrowUpRight } from "lucide-react";

export default function ComingSoon() {
  return (
    <div className="kann-page" data-testid="coming-soon-page">
      <ParticleField />
      <div className="grain" />
      <div className="vignette" />

      <header className="kann-topbar reveal" style={{ "--d": "0s" }}>
        <div className="kann-logo" data-testid="kann-logo">
          KANN<span className="dot">.</span>
        </div>
        <div className="kann-badge" data-testid="status-badge">
          <span className="pulse" />
          In production
        </div>
      </header>

      <main className="kann-main">
        <div className="eyebrow reveal" style={{ "--d": "0.15s" }} data-testid="eyebrow">
          Precision 3D-printed accessories for the smart home
        </div>

        <h1 className="headline reveal" style={{ "--d": "0.28s" }} data-testid="headline">
          Something precise
          <br />
          is <span className="accent">taking shape<span className="dot">.</span></span>
        </h1>

        <p className="subhead reveal" style={{ "--d": "0.42s" }} data-testid="subhead">
          We're building a new home for KANN — holders, mounts and stands
          designed to disappear into your interior. Designed &amp; printed in
          Belgium. Follow along and we'll see you at launch.
        </p>

        <div className="cta-row reveal" style={{ "--d": "0.56s" }}>
          <a
            className="follow-cta"
            href="https://instagram.com/kannprint"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="follow-cta"
          >
            <Instagram size={18} />
            <span>Follow @kannprint</span>
            <ArrowUpRight size={16} className="cta-arrow" />
          </a>
        </div>
      </main>

      <footer className="kann-footer reveal" style={{ "--d": "0.7s" }}>
        <span className="made-in">Designed &amp; 3D-printed in Belgium</span>
        <div className="socials" data-testid="socials">
          <a href="https://instagram.com/kannprint" target="_blank" rel="noopener noreferrer" aria-label="Instagram @kannprint" data-testid="social-instagram">
            <Instagram size={18} />
          </a>
          <a href="https://facebook.com/kannprint" target="_blank" rel="noopener noreferrer" aria-label="Facebook @kannprint" data-testid="social-facebook">
            <Facebook size={18} />
          </a>
          <a href="https://pinterest.com/kannprint" target="_blank" rel="noopener noreferrer" aria-label="Pinterest @kannprint" data-testid="social-pinterest">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M8 20l4-9" />
              <path d="M10.7 14.6a3.5 3.5 0 0 0 6.3-2.1c0-3-2.4-5.5-6-5.5A6 6 0 0 0 5 12.9c0 1.6.7 2.7 1.8 3.2" />
            </svg>
          </a>
        </div>
        <a className="handle" href="https://instagram.com/kannprint" target="_blank" rel="noopener noreferrer" data-testid="handle">
          @kannprint
        </a>
      </footer>
    </div>
  );
}
